import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m14.5 15.5 1-1-14-14-1 1 3.66 3.66C3.18 5.443 3 6.182 3 7.998c0 2.624.374 3 2.999 3q.155 0 .299-.003.321.217.683.456l2.107 1.403c1.467.976 2.2 1.464 2.721.909.143-.153.247-.36.323-.631z"
                    fill="currentColor"
                />
                <path
                    d="m7.32 4.319 1.768-1.177c1.467-.976 2.2-1.465 2.721-.91.522.556.522 1.825.522 4.363V9.33z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SpeakerCrossedFilledSize16Glyph.displayName = 'SpeakerCrossedFilledSize16Glyph';
